import './quantitySelector.css';

/**
 * @name        QuantitySelectorView
 * @desc        init quantity selector behaviours
 * @param       options
 * @param         options.element : jquery object
 * @param         options.rules :
 * @param           options.rules.min (int) : minimum value
 * @param           options.rules.max (int) : maximum value
 * @param           options.rules.msg (str) : error message
 * @param       options.removeCallBack (str) : string to pass to the trigger function to use as callback for remove action
 * @param       options.addCallBack (str) : string to pass to the trigger function to use as callback for add action
 */

import {infoPopinPanelParticipants}  from '../../infoPopinPanelParticipants/infoPopinPanelParticipants.js';

export const QuantitySelectorView = Backbone.View.extend({

  initialize(options) {
    const defaultRules = {
      'min': 0,
      'max': 20,
      'useSelectorDefaultCheck': true
    };
    this.setElement(options.element);
    this.rules = typeof options.rules !== 'undefined' ? options.rules : defaultRules;
    this.options = options;
    this.useSelectorDefaultCheck = this.rules.useSelectorDefaultCheck;
    //updates button status
    this.maximum = Number.isInteger(this.rules.max) ? this.rules.max : defaultRules.max;
    this.minimum = Number.isInteger(this.rules.min) ? this.rules.min : defaultRules.min;
    this.$quantityBlock = this.$el.find('.js-formQuantityValue').eq(0);
    this.$substractor = this.$el.find('.js-quantitySelect.form-QuantityRemover').eq(0);
    this.$adder = this.$el.find('.js-quantitySelect.form-QuantityAdder').eq(0);

    const quantity = parseInt(this.$quantityBlock.val());

    if (quantity >= this.maximum) {
      this.$quantityBlock.val(this.maximum);
      if (GLOBAL_SCRIPTS.MARKET_CODE === 'nl') {
        this.$adder.addClass('u-disabled');
      }
    }

    this.checkButtonStatus();

    if (this.el && this.el.id !== '') {
      $('#' + this.el.id + ' .js-quantitySelect').off('click').on('click', event => {
        // Check if it's an person for SC and MC (Don't show limit message for animals)
        const isPerson = $(event.currentTarget).closest('[id^="searchEngine-pets"]').length === 0;
        if ($(event.currentTarget).hasClass('u-disabled') && isPerson) {
          let htmlInfoMoreCottage = '';
          let urlContact = $('.qb--content .mainLink').data().urlcontact;
          if ($(event.currentTarget).hasClass('form-QuantityAdder')) {
            if ($(event.currentTarget).parents('.js-quantitySelect').attr('id') === '#searchEngine-cottage' && !$('.searchForm-capacityContainer').hasClass('searchForm-panel--bigger')) {
              htmlInfoMoreCottage = infoPopinPanelParticipants({
                textBegin: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreMoreMoreAccomodationBegin,
                textEnd: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreMoreAccomodationEnd,
                jsClass: ' js-contactezNous',
                urlContact: urlContact,
                hasToDisplayPhoneNumber: true
              });

              if (DEVICE.isMobile) {
                $('body').append(`<div class="searchForm-quantityBlock--information">${htmlInfoMoreCottage}</div>`).addClass('popinOpened');
              } else {
                $('.searchForm-quantityBlock--information').html(htmlInfoMoreCottage).removeClass('hidden');
              }

              /* TRACKING */
              Tracking.dataLayerPush({
                clickCode: '',
                gaCategory: PAGE_SCRIPTS.page_template,
                gaAction: 'Multicottage-Popin accommodation',
                gaLabel: 'Max reached accommodation',
                event: 'clickEvent'
              });
            } else if (!$('.searchForm-capacityContainer').hasClass('searchForm-panel--bigger') && ($(event.currentTarget).parents('.js-quantitySelect').attr('id') === 'searchEngine-seniors' || $(event.currentTarget).parents('.js-quantitySelect').attr('id') === 'searchEngine-adults')) {
              htmlInfoMoreCottage = infoPopinPanelParticipants({
                textBegin: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreAccomodationBegin,
                textEnd: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreAccomodationEnd,
                jsClass: ' js-openCottage',
                urlContact: false,
                hasToDisplayPhoneNumber: false
              });

              /* TRACKING */
              if (!$('.searchForm-capacityContainer').hasClass('searchForm-panel--bigger')) {
                Tracking.dataLayerPush({
                  clickCode: '',
                  gaCategory: PAGE_SCRIPTS.page_template,
                  gaAction: 'Multicottage - max reached',
                  gaLabel: 'Popin display',
                  event: 'Popin display'
                });
              }
            } else {
              htmlInfoMoreCottage = infoPopinPanelParticipants({
                textBegin: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreMoreAccomodationBegin,
                textEnd: SEARCH_SCRIPTS.WORDING_SEARCH.facette_participant_moreMoreAccomodationEnd,
                jsClass: ' js-contactezNous',
                urlContact: urlContact,
                hasToDisplayPhoneNumber: true
              });
            }

            if (DEVICE.isMobile) {
              $('body').append(`<div class="searchForm-quantityBlock--information">${htmlInfoMoreCottage}</div>`).addClass('popinOpened');
            } else {
              $('.searchForm-quantityBlock--information').html(htmlInfoMoreCottage).removeClass('hidden');
            }

            $('.js-openCottage').on('click', () => {
              $('#searchEngine-cottage .form-QuantityAdder').click();

              /* TRACKING */
              Tracking.dataLayerPush({
                clickCode: '',
                gaCategory: PAGE_SCRIPTS.page_template,
                gaAction: 'Multicottage - max reached',
                gaLabel: 'Add a second accommodation',
                event: 'clickEvent'
              });
            });

            const operationType = $(event.currentTarget).html() === '+' ? 'max' : $(event.currentTarget).html() === '-' ? 'min' : '';
            let gaAction = 'overlay people - ' + operationType + ' reached';
            let clickCode = 'clickMainSearch';

            if ($(event.target).parents('#js-popinParticipants').length) {
              clickCode = 'clickPopinParticipants';
              gaAction = 'Popin participants - ' + operationType + ' reached';
            }

            Tracking.dataLayerPush({
              clickCode: clickCode,
              gaCategory: PAGE_SCRIPTS.page_template,
              gaAction: gaAction,
              gaLabel: 'add people / add child',
              event: 'clickEvent'
            });
            $('.cp-overlay, .js-closeMessage').on('click', () => {
              $('.searchForm-quantityBlock--information').addClass('hidden');
              if (DEVICE.isMobile) {
                $('body').removeClass('popinOpened');
                $('.searchForm-quantityBlock--information').html();
              }
            });
          } else {
            if ($('.searchForm-quantityBlock--information').length > 0) {
              if (DEVICE.isMobile) {
                $('body').removeClass('popinOpened');
                $('.searchForm-quantityBlock--information').html();
              } else {
                $('.searchForm-quantityBlock--information').addClass('hidden');
              }
            }
          }
        } else {
          this.setQuantity(event);
          $('.searchForm-quantityBlock--information').addClass('hidden');
          $('body').removeClass('popinOpened');
        }
      });
    }
  },

  setQuantity(event) {
    event.preventDefault();

    const $currentTarget = $(event.currentTarget),
      action = $currentTarget.data('action');
    let quantity = parseInt(this.$quantityBlock.val()),
      callback = '';
    if (action === 'substract') {
      if (quantity > this.minimum) {
        quantity = --quantity;
      }
      this.$quantityBlock.removeClass('u-disabled');
      this.$quantityBlock.val(quantity);

      if (typeof this.options.removeCallBack !== 'undefined') {
        callback = this.options.removeCallBack;
      }
    } else {
      if (quantity < this.maximum) {
        quantity++;
        this.$quantityBlock.removeClass('u-disabled');
        this.$quantityBlock.val(quantity);

        if (typeof this.options.addCallBack !== 'undefined') {
          callback = this.options.addCallBack;
        }
      }
    }

    //callback replace the checkButtonStatus
    if (callback !== '') {
      const searchEngineAdultsSelector = '#searchEngine-adults';
      const searchEngineAdultsSelectorMulticottage = '#searchEngine-adults_02';
      const searchEngineSeniorsSelector = '#searchEngine-seniors';
      const searchEngineSeniorsSelectorMulticottage = '#searchEngine-seniors_02';
      const searchEngineChildrenSelector = '#searchEngine-children';
      const searchEngineChildrenSelectorMulticottage = '#searchEngine-children_02';
      const searchEnginePetsSelector = '#searchEngine-pets';
      const searchEnginePetsSelectorMulticottage = '#searchEngine-pets_02';
      const isAdult = ($currentTarget.is(searchEngineAdultsSelector) || $currentTarget.closest(searchEngineAdultsSelector).length) || ($currentTarget.is(searchEngineAdultsSelectorMulticottage) || $currentTarget.closest(searchEngineAdultsSelectorMulticottage).length);
      const isSenior = ($currentTarget.is(searchEngineSeniorsSelector) || $currentTarget.closest(searchEngineSeniorsSelector).length) || ($currentTarget.is(searchEngineSeniorsSelectorMulticottage) || $currentTarget.closest(searchEngineSeniorsSelectorMulticottage).length);
      const isChild = ($currentTarget.is(searchEngineChildrenSelector) || $currentTarget.closest(searchEngineChildrenSelector).length) || ($currentTarget.is(searchEngineChildrenSelectorMulticottage) || $currentTarget.closest(searchEngineChildrenSelectorMulticottage).length);
      const isPet = ($currentTarget.is(searchEnginePetsSelector) || $currentTarget.closest(searchEnginePetsSelector).length) || ($currentTarget.is(searchEnginePetsSelectorMulticottage) || $currentTarget.closest(searchEnginePetsSelectorMulticottage).length);
      if (isAdult || isPet || isSenior || isChild) {
        Tracking.dataLayerPush({
          event: 'click',
          page_type: PAGE_SCRIPTS.page_template,
          area: 'overlay people',
          cta_clicked: action + ` ${isAdult ? 'adult' : isSenior ? 'senior' : isChild ? 'child' : 'animal'}`
        });
      }
      dispatcher.trigger(callback, this.options.identifier, quantity);
    } else {
      this.checkButtonStatus();
    }
  },

  checkButtonStatus() {
    if (this.useSelectorDefaultCheck) {
      const quantity = parseInt(this.$quantityBlock.val());
      if (quantity < this.maximum) {
        this.$adder.removeClass('u-disabled');
      } else if (quantity === this.maximum) {
        this.$adder.addClass('u-disabled');
      }

      if (quantity > this.minimum) {
        this.$substractor.removeClass('u-disabled');
      } else if (quantity === this.minimum) {
        this.$substractor.addClass('u-disabled');
      }

      if (quantity === 0) {
        this.$quantityBlock.addClass('u-disabled');
      } else {
        this.$quantityBlock.removeClass('u-disabled');
      }
    }
  }
});